export default function never() {
  return false;
}
